import React from 'react';
import { useBarcode } from 'react-barcodes';
import PropTypes from 'prop-types';
import {
  Card, CardContent, Container,
  Table, TableBody, TableCell,
  TableRow, Divider
} from '@material-ui/core';
import Page from 'src/components/Page';
import { makeStyles } from '@material-ui/styles';
import { getUser } from 'src/utils/Common';
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }, backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  resize: {
    fontSize: 50
  },
}));


function BarcodeImage({ Barcode, Name, Phone, Address, KargoOdemeDurum }) {


  const classes = useStyles();
  const today = moment(new Date()).format('DD.MM.YYYY');
  const { inputRef } = useBarcode({
    value: Barcode
  });
  const SessionUser = getUser();

  return (
    <Page className={classes.root}>
      <Container maxWidth="xl">
        <Card>
          <CardContent>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left" >
                    Gönderici:
                  </TableCell>
                  <TableCell align="left" >
                    {SessionUser.ServiceShopCode + ' ' + SessionUser.ServiceShopName + ' Arçelik Beko Yetkili Servisi'}
                  </TableCell>
                  <TableCell align="left" >
                    {today}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colspan="3" >
                    <Divider />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colspan="3" >
                    Alıcı Bilgileri
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" >
                    İsim:
                  </TableCell>
                  <TableCell align="left" colspan="2">
                    {Name + ' Arçelik Beko Yetkili Servisi'}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" >
                    Telefon:
                  </TableCell>
                  <TableCell align="left" colspan="2">
                    {Phone}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" >
                    Adres:
                  </TableCell>
                  <TableCell align="left" colspan="2">
                    {Address}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colspan="3" >
                    <Divider />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colspan="3" >
                    {'Standart Kargo ' + KargoOdemeDurum}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colspan="3" >
                    <Divider />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    EntegrasyonNo:
                  </TableCell>
                  <TableCell align="left" colspan="2">
                    {Barcode}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colspan="3">
                    <svg ref={inputRef} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </Container>

    </Page>
  );
};

BarcodeImage.propTypes = {
  className: PropTypes.string,
  EtiketNo: PropTypes.string,
};


export default BarcodeImage;
